import { routes } from '@frontend/router/routes';

const prefix = 'dashboard-navigation:';
const belongsTo = (pathname: string, root: string) => pathname === root || pathname.startsWith(`${root}/`);

export function rememberDashboardLocation(userId: string | undefined, url: string) {
  if (!userId) return;
  const [pathname] = url.split(/[?#]/);
  if (!belongsTo(pathname, routes.dashboard.index)) return;
  try {
    sessionStorage.setItem(`${prefix}${userId}:last`, url);
    sessionStorage.setItem(`${prefix}${userId}:${pathname}`, url);
    if (belongsTo(pathname, routes.dashboard.inbox)) {
      sessionStorage.setItem(`${prefix}${userId}:${routes.dashboard.inbox}`, url);
    }
  } catch {
    /* Navigation still works when storage is unavailable. */
  }
}

export function dashboardReturnUrl(userId: string | undefined, root = routes.dashboard.index): string {
  if (!userId) return root;
  try {
    const value = sessionStorage.getItem(`${prefix}${userId}:${root === routes.dashboard.index ? 'last' : root}`);
    if (value && belongsTo(value.split(/[?#]/)[0], root)) return value;
  } catch {
    /* Fall back to the section's entry route. */
  }
  return root;
}
